<template>
    <div class="cx_topics">
        <div class="cx_title_container"><span class="title cx_link_item" @click="onClick">{{item.title}}</span><span class="badge" v-if="isNew">New</span> </div>
        <span class="timestamp">{{item.from | topicsGroup }}@{{ item.lastUpdatedOn | timestamp}}</span>        
        <span class="contenxt">{{getDescription()}}</span>        
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue} from 'vue-property-decorator';
import * as Common from "@/agiles/common";

@Component
export default class Topics extends Vue {
  @Prop({default:''}) public item : Common.Topics;

   public getDescription(){
       if (this.item.content.length < 50) return this.item.content;
       else return this.item.content.substring(0,49) + '...';
   }
   public get isNew(){
       var dt = new Date();
       dt.setHours(dt.getHours() -72);
    //    return new Date(Date.parse(this.item.lastUpdatedOn as any)) > dt;
       return this.item.lastUpdatedOn > dt;    
   }
    public onClick(){
        this.$router.push(String.format('/operation/Topics?id={0}&isAdmin={1}', this.item.id,this.item.isAdmin));
    }
}
</script>
<style lang="scss">
.cx_topics{
    margin:5px;
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;    
    font-size: 12px;

    span{
       text-align: left;
    }

    .title{
        font-weight: 700;
    }
    .timestamp{
        margin-bottom: 5px;
        font-size:11px;
    }

    .cx_title_container{
        display: flex;        
    }
    .badge{
        // position: absolute;
        top : -7px;
        right : -7px;
        margin-left: 10px;
        font-size:11px;
        text-shadow: none;
        background-color: rgb(1, 10, 136);
        color:white;
        // border-radius: 10rem;
        border-radius: 8px;
        height: 16px;
        padding-top: 2px;

    }    
}
</style>